<template>
  <div class="navbar">
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    <div class="right-menu">
      <a  v-if="user_type==1" class="doc-area" href="https://bluefocus.feishu.cn/docx/IoEKdcSvloTgn8x5dI8cwjNVn36" target="_blank">
        <i class="fa fa-question-circle fa-lg"></i>
      </a>

      <a  v-else class="doc-area" href="https://bluefocus.feishu.cn/docx/NJc3dbJzbo1EdJxd7Nyc715pnke" target="_blank">
        <i class="fa fa-question-circle fa-lg"></i>
      </a>
  

      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <span class="name">{{ user.username }}</span>
          <i class="el-icon-caret-bottom" />
        </div>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="logout">
            <span style="display: block">退出登陆</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import Hamburger from "@src/components/Hamburger";
import Breadcrumb from "@src/components/Breadcrumb";
import { mapState } from "pinia";
import { useAppStore,useUserStore } from "@/store/pinia";
import { removeToken } from "@src/utils/auth";
export default {
  data() {
    return {
      user_type:this.$user.user_type
    };
  },
  components: {
    Hamburger,
    Breadcrumb,
  },
  computed: {
    ...mapState(useAppStore, ["sidebar",'device']),
    ...mapState(useUserStore, ["avatar",'user']),
  },
  methods: {
    toggleSideBar() {
      let appStore = useAppStore();
      appStore.handleToggleSidebar();
    },
    async logout() {
      let userId = JSON.parse(localStorage.getItem("system_user"))?.id;
      let overviewFlag = localStorage.getItem(`overviewFlag${userId}`)
      sessionStorage.clear();
      localStorage.clear()
      removeToken();
      localStorage.setItem(`overviewFlag${userId}`,overviewFlag);
      let userStore = useUserStore();
      await  userStore.handleLogout();
      window.location.reload(true);
      this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    display: flex;
    .doc-area {
      display: inline-block;
      padding: 8px 30px 0;
      .fa-question-circle {
        color: #909399;
      }
    }

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .name {
          font-size: 14px;
          color: #909399;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
